import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, getConfig } from "../../../../utils";

export const delSession = createAsyncThunk('delSession', async (data) => {
    try {
        const res = await axios({

            method: 'PUT',
            url: getConfig.API_URL + `session/${data?.id}`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})
